<div id="main">
  <div id="container-1" class="container">
    @if (fuseConfig.layout.navbar.position === 'left') {
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    }
    <div id="container-2" class="container">
      @if (fuseConfig.layout.toolbar.position === 'below-fixed') {
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      }

      <div
        id="container-3"
        class="container"
        cdkScrollable
        fusePerfectScrollbar
        [fusePerfectScrollbarOptions]="{ suppressScrollX: true, updateOnRouteChange: true }"
      >
        <div class="layout-content">
          @if (loading) {
            <div class="black-overlay"><mat-spinner></mat-spinner></div>
          }
          @if (true) {
            <router-outlet></router-outlet>
          }
        </div>
      </div>
    </div>

    <app-manuale></app-manuale>
  </div>
</div>

@if (shouldQuickPanelBeOpenable | async) {
  <fuse-sidebar name="quickPanel" position="right" class="quick-panel">
    <quick-panel></quick-panel>
  </fuse-sidebar>
}

<ng-template #toolbar>
  @if (!fuseConfig.layout.toolbar.hidden) {
    <toolbar class="below-fixed"></toolbar>
  }
</ng-template>

<ng-template #leftNavbar>
  @if (!fuseConfig.layout.navbar.hidden) {
    <fuse-sidebar
      name="navbar"
      class="navbar-fuse-sidebar"
      [folded]="fuseConfig.layout.navbar.folded"
      lockedOpen="gt-md"
    >
      <navbar [variant]="fuseConfig.layout.navbar.variant" class="left-navbar"></navbar>
      <!--[ngClass]="fuseConfig.layout.navbar.background" -->
    </fuse-sidebar>
  }
</ng-template>
